<div class="top-bar"></div>
<div class="outer-container" fxLayout="row" fxLayoutAlign="center">
  <div class="settings-container">
    <div class="heading">
      Notifications
    </div>
    <mat-card class="notification-group mb-2" *ngFor="let group of notificationService.notifications$ | async">
      <mat-card-header>
        <mat-card-title>{{ group.name }}</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div
          class="notification"
          saAutomatedSelector="notification__row"
          [automatedName]="notification.name"
          *ngFor="let notification of group.notifications; trackBy: notificationTrackBy"
        >
          <span class="name" saAutomatedSelector="notification__name">{{ notification.name }}</span>
          <span
            class="toggle"
            saAutomatedSelector="notification__emailContainer"
            [class.enabled]="notification.emailEnabled"
            (click)="notificationService.updateEmailNotification(notification.id, !notification.emailEnabled)"
          >
            <mat-icon class="clickable" *ngIf="notification.emailActive">email</mat-icon>
          </span>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
